export default __webpack_public_path__ + "static/media/check.74c16a85.svg";